import { createBrowserHistory } from 'history';

export default createBrowserHistory();

export const uriChangeHandled = 'uri change handled';
